import _ from 'lodash'
import Backbone from 'backbone'
import FormView from 'scoreboard/components/form-view'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import template from './edit-label.hbs'
import i18n from 'scoreboard/components/i18n'

const EditLabel = Backbone.View.extend({

	tagName: 'form',

	/**
	 * Common view for editing the label of a designer report/chart
	 *
	 * @param {String} options.label The initial value of the custom label
	 *
	 * @param {Boolean} [options.default=false] true if the labeled toggle should
	 * show the default option as the initial selected option
	 *
	 * @param {String} [options.header=report.designer.setColumnLabel] the i18n
	 * code to use as the dialog header
	 *
	 * @param {String} [options.inputLabel=report.designer.columnLabel] the i18n
	 * code to use for the input's label
	 *
	 * @param {String} [options.toggleLabel=report.designer.labelType] the i18n
	 * code to use for the label for the default/custom toggle
	 */
	initialize: function(options = {}) {
		this.options = _.extend({
			header: 'report.designer.setColumnLabel',
			inputLabel: 'report.designer.columnLabel',
			toggleLabel: 'report.designer.labelType'
		}, options)

		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: () => {
				let label = this.toggle.val() == 'custom' ? this.$('[name=label]').val() : null
				this.trigger('done', label)
			}
		})

		this.toggle = new LabeledToggle({
			value: this.options.default ? 'default' : 'custom',
			options: [ {
				value: 'default',
				label: 'common.default'
			}, {
				value: 'custom',
				label: 'admin.calendar.custom'
			} ]
		})

		this.toggle.on('change', (val) => {
			this.$('.dialog-body').toggleClass('is-not-displayed', val == 'default')
		})
	},

	render: function() {
		this.formView.start()
		this.$el.html(template(this.options))

		this.$('.dialog-body').toggleClass('is-not-displayed', !!this.options.default)
		this.$('.display-toggle').append(this.toggle.el)
		this.toggle.render()

		if (this.options.customOnly) {
			this.$('.toggle-container')
				.remove()
		}

		if (this.options.doneKey) {
			this.$('.save').text(i18n.get(this.options.doneKey))
		}
		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.toggle], 'remove')
	}

})

export default EditLabel
EditLabel.__filename__ = 'components/designer/edit-label.js'
